module.exports = __webpack_public_path__ + "static/media/bogazici-filarmoni-orkestrasi-2.93d8412a.mp4";